// Action type constants
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const SIGN_UP_REQUEST = 'SIGN_UP_REQUEST';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

export const RECOVERY_PASSWORD_REQUEST = 'RECOVERY_PASSWORD_REQUEST';
export const RECOVERY_PASSWORD_SUCCESS = 'RECOVERY_PASSWORD_SUCCESS';
export const RECOVERY_PASSWORD_FAILURE = 'RECOVERY_PASSWORD_FAILURE';

export const SEND_CODE_REQUEST = 'SEND_CODE_REQUEST';
export const SEND_CODE_SUCCESS = 'SEND_CODE_SUCCESS';
export const SEND_CODE_FAILURE = 'SEND_CODE_FAILURE';

export const SET_AUTH_ERRORS = 'SET_AUTH_ERRORS';
export const CLEAR_AUTH_ERRORS = 'CLEAR_AUTH_ERRORS';

export const SET_USER_PHONE = 'SET_USER_PHONE';

export const RESTORE_PASSWORD_REQUEST = 'RESTORE_PASSWORD_REQUEST';
export const RESTORE_PASSWORD_SUCCESS = 'RESTORE_PASSWORD_SUCCESS';
export const RESTORE_PASSWORD_FAILURE = 'RESTORE_PASSWORD_FAILURE';

// State interface
export interface AuthState {
  isLoading: boolean;
  errors: {
    login?: string | null;
    signUp?: string | null;
    sendCode?: string | null;
  };
  code: string;
  phone: string;
}

// Form props interfaces
export interface SignUpFormProps {
  firstName: string;
  lastName: string;
  phone: string;
  confirmationCode: string;
  password: string;
  confirmPassword: string;
}

export interface LoginFormProps {
  phone: string;
  password: string;
}

export interface ResetPasswordFormProps {
  phoneNumber: string;
  code: number;
  password: string;
  passwordSubmit: string;
}
